import { isPlainObject, mapValues } from "lodash";
import { migrateSpacingToken, migrateColorToken } from "./v8-to-v10.esm.js";
function v8ResponsiveToPanda(v8Obj, mapValueFn) {
  const defaultVal = v8Obj.default;
  const lgLteVal = v8Obj.lg_lte;
  const smLteVal = v8Obj.sm_lte;
  const map = mapValueFn || ((v) => v);
  const hasDefault = "default" in v8Obj;
  const hasLgLte = "lg_lte" in v8Obj;
  const hasSmLte = "sm_lte" in v8Obj;
  if (hasDefault && hasLgLte && hasSmLte) {
    return {
      base: map(smLteVal),
      md: map(lgLteVal),
      xl: map(defaultVal)
    };
  }
  if (hasDefault && hasLgLte) {
    return {
      base: map(lgLteVal),
      xl: map(defaultVal)
    };
  }
  if (hasDefault && hasSmLte) {
    return {
      base: map(smLteVal),
      md: map(defaultVal)
    };
  }
  if (hasLgLte && hasSmLte) {
    return {
      base: map(smLteVal),
      md: map(lgLteVal),
      xl: "none"
    };
  }
  if (hasDefault) {
    return {
      base: map(defaultVal)
    };
  }
  if (hasSmLte) {
    return {
      base: map(smLteVal),
      md: "none"
    };
  }
  if (hasLgLte) {
    return {
      base: map(lgLteVal),
      xl: "none"
    };
  }
  const result = {};
  Object.entries(v8Obj).forEach(([k, v]) => {
    result[k] = map(v);
  });
  return result;
}
function resolveSpacing(value) {
  if (!value) return void 0;
  if (typeof value === "string") {
    return migrateSpacingToken(value);
  }
  if (typeof value === "object") {
    const keys = Object.keys(value);
    if (keys.length === 0) return void 0;
    if (keys.length === 1) {
      if (keys[0] === "default") {
        const val = value.default;
        return val ? migrateSpacingToken(val) : void 0;
      }
      const responsive2 = v8ResponsiveToPanda(value, (v) => v ? migrateSpacingToken(v) : void 0);
      return Object.keys(responsive2).length > 0 ? responsive2 : void 0;
    }
    const responsive = v8ResponsiveToPanda(value, (v) => v ? migrateSpacingToken(v) : void 0);
    return Object.keys(responsive).length > 0 ? responsive : void 0;
  }
  return void 0;
}
function resolveTextAlign(textAlign) {
  if (!textAlign) return void 0;
  if (typeof textAlign === "string") {
    return textAlign === "inherit" ? void 0 : textAlign;
  }
  if (typeof textAlign === "object") {
    const keys = Object.keys(textAlign);
    if (keys.length === 0) return void 0;
    if (keys.length === 1 && keys[0] === "default" && textAlign.default === "inherit") {
      return void 0;
    }
    const normalized = {
      default: "inherit",
      ...textAlign
    };
    if (Object.values(normalized).every((v) => v === "inherit")) {
      return void 0;
    }
    const responsive = v8ResponsiveToPanda(normalized);
    return Object.keys(responsive).length > 0 ? responsive : void 0;
  }
  return void 0;
}
function resolveColor(fontColor) {
  if (!fontColor) return void 0;
  const v10Color = migrateColorToken(fontColor);
  if (!v10Color || v10Color === "text.neutral") return void 0;
  return v10Color;
}
function migrateResponsiveValue(value, mapFn) {
  if (!value) return value;
  if (isPlainObject(value)) {
    return mapValues(value, (v) => isPlainObject(v) ? migrateResponsiveValue(v, mapFn) : mapFn(v));
  }
  return mapFn(value);
}
function migrateResponsiveSpacing(spacingObj, mapFn) {
  if (!spacingObj || !isPlainObject(spacingObj)) return spacingObj;
  return mapValues(spacingObj, (value) => migrateResponsiveValue(value, mapFn));
}
export {
  migrateResponsiveSpacing,
  migrateResponsiveValue,
  resolveColor,
  resolveSpacing,
  resolveTextAlign,
  v8ResponsiveToPanda
};
